export default {
  title: 'Page not found',
  description: 'The address you visited may have been removed, is temporarily unavailable, or the link may be incorrect.',
  backToHome: 'Back to project home',
  goBack: 'Go back',
}
